import React, { useEffect, useState } from 'react';
import { Tab, TabList, Tabs } from '@mui/joy';
import InflowPage from './InflowPage';
import EnrollmentTrend from './EnrollmentTrend';
import ConsultationStats from './ConsultationStats';

const ChartsMain: React.FC<any> = (props: any) => {

    const [menu, setMenu] = useState(0);

    useEffect(() => {
        props.activateMenuList("datachart");
    }, []);

    return (
        <div style={{
            width: "calc(100% - 244px)",
            height: "calc(100vh - 78px)",
            overflow: "auto",
            background: "#F3F4F6",
            boxSizing: "border-box",
        }}>
            <Tabs
                value={menu}
                onChange={(_, v) => setMenu(v as number)}
                sx={{ background: "#fff", borderBottom: "1px solid #E5E7EB" }}
            >
                <TabList>
                    <Tab>학원유입</Tab>
                    <Tab>충원율 추이</Tab>
                    <Tab>방문상담</Tab>
                </TabList>
            </Tabs>

            {menu === 0 && <InflowPage {...props} />}
            {menu === 1 && <EnrollmentTrend {...props} />}
            {menu === 2 && <ConsultationStats {...props} />}
        </div>
    );
};

export default ChartsMain;
